import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";

const resourceTableDefinitionDataZodObject = z
    .object({
        _type: z.literal("RESOURCE_TABLE"),
        title: requiredTranslatableZodSchema,
        subtitle: translatableZodSchema,
        description: translatableZodSchema,
        quantity: z.number(),
    })
    .partial()
    .required({ _type: true, title: true });

type ResourceTableDefinitionData = z.infer<
    typeof resourceTableDefinitionDataZodObject
>;

const _resourceTableDefinitionDataFactoryParamsZodObject =
    resourceTableDefinitionDataZodObject.omit({
        _type: true,
    });

type ResourceTableDefinitionDataFactoryParams = z.infer<
    typeof _resourceTableDefinitionDataFactoryParamsZodObject
>;

const resourceTableDefinitionDataFactory = (
    params: ResourceTableDefinitionDataFactoryParams,
): ResourceTableDefinitionData => {
    return {
        ...params,
        _type: "RESOURCE_TABLE",
    };
};

export {
    resourceTableDefinitionDataFactory,
    resourceTableDefinitionDataZodObject,
};
export type {
    ResourceTableDefinitionData,
    ResourceTableDefinitionDataFactoryParams,
};
